/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Utils } from 'vmf';
import { Sv } from './Sv';

const { GlobalVar } = Utils;

class Question extends Sv {
    constructor() {
        super();
        this.baseUrl += '/question';
    }

    data({ title, questionCatId, questionType, option, currentPage, pageSize } = {}) {
        return super.get('/data', {
            title,
            questionCatId,
            questionType,
            option,
            currentPage,
            pageSize,
        });
    }

    getDetail({ id }) {
        return super.get('/get', { id }).then(json => {
            const { attachment } = json.data.data;
            if (!attachment) {
                json.data.data.attachment = [];
            } else {
                json.data.data.attachment = attachment.split(',').reduce((prev, curr) => {
                    prev.push({
                        name: curr,
                        address: GlobalVar.fileBasePath + curr,
                    });
                    return prev;
                }, []);
            }
            return json;
        });
    }

    save({
        id,
        questionCatId,
        title,
        answerAnalysis,
        questionType,
        questionOptionType,
        questionAnswer,
        attachment,
        optionConfig,
    } = {}) {
        const attachmentStr = attachment
            .reduce((prev, curr) => {
                prev.push(curr.name);
                return prev;
            }, [])
            .join(',');
        return super.post('/save', {
            id,
            questionCatId,
            title,
            answerAnalysis,
            questionType,
            questionOptionType,
            questionAnswer,
            attachment: attachmentStr,
            optionConfig,
        });
    }

    delete({ ids } = {}) {
        return super.post('/delete', {
            ids,
        });
    }
}

export default new Question();
export { Question };
